export enum StepActionType {
  YEARLY_CONSULTATION_LINK,
  PLAN_TRIP_LINK,
  SCHEDULE_CALL,
  PLAN_TRIP,
  SKIP,
  FINISH,
}
